import { Vue, Component } from "nuxt-property-decorator"
import { replaceUrlS3Helper } from "~/scripts/useful-functions"

@Component
export default class ImageUrlS3 extends Vue {
  replaceUrlS3(url: string) {
    return replaceUrlS3Helper(url, this.$config.cdnUrl, this.$config.graphqlEndpoint)
  }
}
